<div class="header-notification">
  <button
    pButton
    type="button"
    icon="pi pi-bell"
    [rounded]="true"
    [text]="true"
    styleClass="header-icon-btn"
    [attr.aria-label]="'notifications.bell.label' | translate"
    (click)="openPanel()"
  ></button>
  @if (unreadCount() > 0) {
    <span class="header-notification__badge" [class.header-notification__badge--error]="hasError()">
      {{ unreadCount() > 99 ? '99+' : unreadCount() }}
    </span>
  }
</div>

<p-drawer
  [(visible)]="panelOpen"
  position="right"
  [style]="{ width: '22rem' }"
  [modal]="true"
  [dismissible]="true"
  (onHide)="closePanel()"
>
  <ng-template pTemplate="header">
    <div class="notif-panel__header">
      <span class="notif-panel__title">{{ 'notifications.panel.title' | translate }}</span>
      @if (unreadCount() > 0) {
        <button
          pButton
          type="button"
          [label]="'notifications.panel.markAllRead' | translate"
          [text]="true"
          size="small"
          class="notif-panel__mark-all"
          (click)="markAllRead()"
        ></button>
      }
    </div>
  </ng-template>

  <div class="notif-panel__body">
    @if (loading()) {
      <div class="notif-panel__loading">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      </div>
    } @else if (notifications().length === 0) {
      <div class="notif-panel__empty">
        <i class="pi pi-bell-slash" aria-hidden="true"></i>
        <p>{{ 'notifications.panel.empty' | translate }}</p>
      </div>
    } @else {
      <ul class="notif-list">
        @for (notif of notifications(); track notif.documentId) {
          <li
            class="notif-item"
            [class.notif-item--unread]="!notif.readAt"
            [ngClass]="severityClass(notif.severity)"
            [attr.role]="notif.deepLink ? 'button' : 'listitem'"
            [attr.tabindex]="notif.deepLink ? 0 : null"
            (click)="navigateTo(notif)"
            (keydown.enter)="navigateTo(notif)"
          >
            <span class="notif-item__icon">
              <i [class]="severityIcon(notif.severity)" aria-hidden="true"></i>
            </span>
            <div class="notif-item__content">
              <span class="notif-item__title">{{ notif.title }}</span>
              @if (notif.body) {
                <span class="notif-item__body" [class.notif-item__body--expanded]="isExpanded(notif.documentId)">{{
                  notif.body
                }}</span>
                @if (isBodyExpandable(notif.body)) {
                  <button type="button" class="notif-item__more" (click)="toggleBody(notif.documentId, $event)">
                    {{
                      (isExpanded(notif.documentId) ? 'notifications.panel.viewLess' : 'notifications.panel.viewMore')
                        | translate
                    }}
                  </button>
                }
              }
              <span class="notif-item__date">{{ notif.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
            </div>
            @if (!notif.readAt) {
              <button
                pButton
                type="button"
                icon="pi pi-circle-fill"
                [text]="true"
                [rounded]="true"
                size="small"
                class="notif-item__read-btn"
                [attr.aria-label]="'notifications.panel.markRead' | translate"
                (click)="markRead(notif, $event)"
              ></button>
            }
          </li>
        }
      </ul>
    }
  </div>
</p-drawer>
